
import React from "react";
import { useDetail, useSave } from "seed/gql";
import { SAVE_FLOW_NOTE } from "seed/gql/queries";
import View from "components/presentation/history/notes/NoteFormView.view"

const FlowNoteForm = ({ flow, messageId, closeModal, refreshNotes }) => {

  const userId = sessionStorage.getItem("id");
  const isMessageNote = messageId !== undefined && messageId !== null;

  const reqMessage = useDetail(`{
    chatMessage { 
      action
      content
    }  
  }`, messageId);

  const [callSaveNote] = useSave(SAVE_FLOW_NOTE, {
    onCompleted: (data) => {
      refreshNotes();
      closeModal();
    }
  });

  const onClickSave = (values) => {
    callSaveNote({
      ...values,
      settings: {},
      flow: { id: flow.id },
      user: { id: userId },
      ...(messageId ? { message: { id: messageId } } : {})
    })
  }

  const message = reqMessage?.data.chatMessage || {};

  return <View
    message={message}
    isMessageNote={isMessageNote}
    onClickSubmit={onClickSave}
  />;

}

export default FlowNoteForm;